import React from "react";

const RightBottom = () => {
    return (
        <div className="col-11">
            <div className="row gx-2 justify-content-evenly align-items-center">
                <div className="col-12">
                    <h3 class="mb-3 fs-4">Experience</h3>
                    <hr
                        className="border border-secondary w-25 marg-cs"
                        dir="ltr"
                    />
                    <div
                        className="row justify-content-start bg-card-hover rounded-2 shadow-sm pt-2 align-items-center d-flex mb-2"
                        style={{ minHeight: "6rem" }}
                    >
                        <p className="text-light col-11">
                            <span style={{ fontSize: "10px" }}>&#127765; </span>
                            <strong>
                                Part Ai Research Center | Backend developer | In
                                Office 2025-12 to present
                            </strong>
                            <br />A research center focused on developing
                            cutting-edge AI technologies with multiple projects
                            in the field of AI and machine learning.
                        </p>
                    </div>
                    <div
                        className="row justify-content-start bg-card-hover rounded-2 shadow-sm pt-2 align-items-center d-flex mb-2"
                        style={{ minHeight: "6rem" }}
                    >
                        <p className="text-light col-11">
                            <span style={{ fontSize: "10px" }}>&#127765; </span>
                            <strong>
                                Freelancer | Backend developer | Remote 2024-09
                                to 2025-12
                            </strong>
                            <br />
                            Independent backend developer crafting APIs and
                            microservices for varied clients.
                        </p>
                    </div>
                    <div
                        className="row justify-content-start bg-card-hover rounded-2 shadow-sm pt-2 align-items-center d-flex mb-3"
                        style={{ minHeight: "6rem" }}
                    >
                        <p className="text-light col-11">
                            <span style={{ fontSize: "10px" }}>&#127765; </span>
                            <strong>
                                OverC | Backend developer | Remote 2024-03 to
                                2024-09
                            </strong>
                            <br />
                            Iranian-Canadian company with an international
                            presence, operating in multiple countries
                        </p>
                    </div>
                </div>

                <div className="col-12">
                    <h3 class="mb-3 fs-4">Education</h3>
                    <hr
                        className="border border-secondary w-25 marg-cs"
                        dir="ltr"
                    />
                    <div
                        className="bg-card-hover rounded-2 shadow-sm pt-2 row justify-content-center mb-2"
                        style={{ minHeight: "6rem" }}
                    >
                        <div className="col-11 align-items-center d-flex">
                            <p className="text-light">
                                <i className="bi bi-mortarboard-fill text-warning"></i>
                                <strong> Software Engineer</strong>
                                <br />
                                Master
                                <br />
                                university Of Since And Culture 2021 to 2025
                            </p>
                        </div>
                    </div>
                    <div
                        className="bg-card-hover rounded-2 shadow-sm pt-2 row justify-content-center mb-2"
                        style={{ minHeight: "6rem" }}
                    >
                        <div className="col-11 align-items-center d-flex">
                            <p className="text-light">
                                <i className="bi bi-mortarboard-fill text-warning"></i>
                                <strong> Software Engineer</strong>
                                <br />
                                Bachelor
                                <br />
                                Azad university 2021 to 2025
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RightBottom;
